// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from 'prop-types';

// Data
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import LandingMap from "nextus/Maps/LandingMap";

// API/MODELS
import deviceAPI from "api/bks";
import clearwaysAPI from "modules/clearways/api"
import MapNav from "nextus/Sidenavs/MapNav";
import EventsBar from "modules/clearways/views/EventsBar";
import MapMenuContent from "nextus/MapMenuContent";
import { processEventsData } from "helper/event";
import { useSoftUIController } from "context";

function wrapper(map, content) {
    return (
        <SoftBox sx={{ width: '100%', height: '100%' }}>
            {map}
            {content}
        </SoftBox>
    );
}

function LandingPage({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) { // LAYER 2

    clearwaysAPI.loadToken(useAuth0());

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [mapPadding, setMapPadding] = useState([600, 290]);
    const [menuToggled, setMenuToggled] = useState(true);
    const [mapSpinSpeed, setMapSpinSpeed] = useState(120);

    const [controller, dispatch] = useSoftUIController();
    const { miniSidenav, hiddenSidenav, direction, layout, openConfigurator, sidenavColor, deviceStyle } = controller;

    const [eventbarState, setEventbarState] = useState('closed');

    const maxSpinZoom = 3;
    const slowSpinZoom = 2;

    const handleMoveEnd = () => {
        setMenuToggled(false);
        spinGlobe();
    }

    function spinGlobe() {
        const zoom = map.current.getZoom();
        // console.log(spinEnabled, userInteracting, zoom);
        if (map.current.getZoom() < maxSpinZoom && mapSpinSpeed > 0) {

            var distancePerSecond = 360 / mapSpinSpeed;
            if (zoom > slowSpinZoom) {
                // Slow spinning at higher zooms
                const zoomDif = (maxSpinZoom - zoom) / (maxSpinZoom - slowSpinZoom);
                distancePerSecond *= zoomDif;
            }
            const center = map.current.getCenter();
            center.lng -= distancePerSecond;
            // Smoothly animate the map over one second.
            // When this animation is complete, it calls a 'moveend' event.
            map.current.easeTo({ center, duration: 1000, easing: (n) => n });
        }
    }

    const events = useQuery({
        queryKey: ['getAllClearways'],
        queryFn: async () => {
            return await clearwaysAPI.getAllClearways();
        },
        // staleTime: 20 * 1000
    });

    useEffect(() => {
        // console.log('landing_page', sidebarState)
        setSidebarState('landing');
        // console.log(sidebarState)

        console.log('deviceStyle: ', deviceStyle);

        if (deviceStyle == 'mobile') {
            setMapPadding([0, 0]);
            // setSidebarOpen(false);
        }
        else {
            if (!sidebarOpen) {
                if (eventbarState == 'open') {
                    setMapPadding([0, 290]);
                }
                else {
                    setMapPadding([0, 0]);
                }
                setSidebarOpen(false);
            }
            else {
                if (eventbarState == 'open') {
                    setMapPadding([600, 290]);
                }
                else {
                    setMapPadding([600, 0]);
                }
                setSidebarOpen(true);
            }
        }

    }, [sidebarState]);

    useEffect(() => { //mount component
        // console.log('landing_page eventbarState', eventbarState)

        var zoom = 2;

        if (deviceStyle == 'mobile') {
            zoom = 1;
        }
        else if (eventbarState == 'open') {
            zoom = 1.7;
        }

        if (map.current) {
            if (menuToggled) {
                map.current.flyTo({
                    center: [0, 0],
                    zoom: zoom
                })
            }
            map.current.on('moveend', handleMoveEnd);
        }

    }, [eventbarState]);

    useEffect(() => () => { //unmount component

        if (map.current) {
            map.current.off('moveend', handleMoveEnd);
        }

    }, [eventbarState]);

    if (events.isLoading) {
        return wrapper((<LandingMap map={map} sidebarOpen={sidebarOpen} extraPadding={eventbarState == 'open'} menuToggled={menuToggled} deviceStyle={deviceStyle} />), ('Loading...'));
    }

    if (events.error) {
        return wrapper((<LandingMap map={map} sidebarOpen={sidebarOpen} extraPadding={eventbarState == 'open'} menuToggled={menuToggled} deviceStyle={deviceStyle} />), ("An error has occurred: " + events.error.message));
    }

    if (!events.data) {
        return wrapper((<LandingMap map={map} sidebarOpen={sidebarOpen} extraPadding={eventbarState == 'open'} menuToggled={menuToggled} deviceStyle={deviceStyle} />), ('Loading...'));
    }

    var events_data = processEventsData(events.data);

    return wrapper(
        (<LandingMap map={map} sidebarOpen={sidebarOpen} extraPadding={events_data.length > 0} menuToggled={menuToggled} deviceStyle={deviceStyle} />),
        (<MapMenuContent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} sidebarState={'landing'} events={events_data} eventbarState={events_data.length > 0 ? 'open' : 'closed'} setEventbarState={setEventbarState} deviceStyle={deviceStyle} />)
    );
}

LandingPage.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func
}

export default LandingPage;